<template>
  <div>
    <div @click="$router.go(-1)" class=" arrow_text cursor-pointer">
      <chevron-left-icon
        size="1.5x"
        class=" custom-class"
        style="vertical-align: top;"
      ></chevron-left-icon>
      <span class=" back">Back</span>
    </div>
    <h1 class=" mt-1 mb-2 font-regular">Send SMS</h1>

    <div class=" row justify-content-center">
      <div class=" col-md-8 col-12">
        <form @submit.prevent="submitFunc">
          <!-- send id -->
          <!-- recipients -->
          <!-- message -->
          <div class="form-group">
            <label for="">Sender ID</label>
            <input
              type="text"
              v-model="sendMessageObj.sender"
              placeholder="Sender ID"
              class="form-control"
            />
          </div>
          <div class=" form-group">
            <label for="type">Type</label>
            <select
              name=""
              class=" form-control form-select"
              id=""
              v-model="sendMessageObj.type"
            >
              <option value="" disabled selected>Please Select Type</option>
              <option value="all">All Customers</option>
              <!-- <option value="test-customer">Test Customers</option> -->
              <option value="specific-customer">Specific Customer</option>
            </select>
          </div>

          <div
            class=" form-group"
            v-if="sendMessageObj.type === 'specific-customer'"
          >
            <label for="">Recipients</label>
            <textarea
              @keypress="isNumber($event)"
              name=""
              id=""
              cols="30"
              rows="6"
              class="form-control"
              style="resize: none;"
              v-model="sendMessageObj.phone_numbers"
            >
            </textarea>
            <div>
              {{
                sendMessageObj.phone_numbers !== ""
                  ? sendMessageObj.phone_numbers.split(",").length
                  : 0
              }}
              Recipient(s)
            </div>
          </div>
          <div class=" form-group">
            <label for="">Message</label>
            <textarea
              name=""
              v-model="sendMessageObj.message"
              id=""
              cols="30"
              rows="7"
              class=" form-control"
              style="resize: none;"
            ></textarea>
            <div v-if="page === 1">
              Characters Remaining: {{ firstPageCharsRemaining }}; Page:
              {{ page }}
            </div>
            <div v-else>
              Characters Remaining: {{ otherPagesCharsRemaining }}; Page:
              {{ page }}
            </div>
          </div>
          <button
            class=" w-100 btn-primary btn"
            type="submit"
            :disabled="sendMessageLoading"
          >
            <span v-if="sendMessageLoading">Please wait</span>
            <span v-else>Send Message</span>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/services/api.service";
import ErrorService from "@/services/error.service";
import Swal from "sweetalert2";

export default {
  name: "SendSMS",
  data() {
    return {
      sendMessageObj: { sender: "", message: "", type: "", phone_numbers: "" },
      inputValue: "",
      firstPageLimit: 160,
      otherPagesLimit: 140,
      send_type: "spec",
      sender_id: "",
      message: "",
      recipients: "",
      charactersPerPage: [160, 140],
      sendMessageLoading: false
    };
  },
  computed: {
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    },
    page() {
      return this.message.length <= this.firstPageLimit
        ? 1
        : Math.ceil(
            (this.message.length - this.firstPageLimit) / this.otherPagesLimit
          ) + 1;
    },
    firstPageCharsRemaining() {
      return Math.max(0, this.firstPageLimit - this.message.length);
    },
    otherPagesCharsRemaining() {
      return Math.max(
        0,
        this.otherPagesLimit * (this.page - 1) -
          (this.message.length - this.firstPageLimit)
      );
    }
  },
  methods: {
    isNumber: function(evt) {
      const regex = /^[0-9,]+$/;
      if (!regex.test(evt.key)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async submitFunc() {
      try {
        this.sendMessageLoading = true;
        console.log(this.sendMessageObj);
        const response = await ApiService.post(
          `utility/send-sms`,
          this.sendMessageObj
        );
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.sendMessageLoading = false;
        this.sendMessageObj.sender = "";
        this.sendMessageObj.type = "";
        this.sendMessageObj.phone_numbers = "";
        this.sendMessageObj.message = "";
        this.$router.push({ name: "smslist" });
      } catch (error) {
        this.sendMessageLoading = false;
        console.log(error);
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    }
  }
};
</script>

<style scoped></style>
